import type { JSX } from 'react';
import { useEffect, useRef, useState } from 'react';
import { studentLogout } from '../state/student-logout';
import { ConfirmModal } from './ConfirmModal';

const LOGOUT_BODY =
  'Chiuderemo la sessione e cancelleremo i dati di studio salvati su questo dispositivo. Per rientrare userai nome utente e password.';
const LOGOUT_ERROR =
  'Non riesco a completare l’uscita. Il tuo accesso e i dati su questo dispositivo sono ancora salvati. Controlla la connessione e riprova.';

interface StudentLogoutModalProps {
  open: boolean;
  onCancel: () => void;
}

type LogoutPhase = 'idle' | 'pending' | 'error';

export function StudentLogoutModal({ open, onCancel }: StudentLogoutModalProps): JSX.Element | null {
  const [phase, setPhase] = useState<LogoutPhase>('idle');
  const pendingRef = useRef(false);

  useEffect(() => {
    if (!open) {
      pendingRef.current = false;
      setPhase('idle');
    }
  }, [open]);

  const confirm = () => {
    if (pendingRef.current) return;
    pendingRef.current = true;
    setPhase('pending');
    void studentLogout.logout().catch(() => {
      pendingRef.current = false;
      setPhase('error');
    });
  };

  const cancel = () => {
    if (pendingRef.current) return;
    setPhase('idle');
    onCancel();
  };

  return (
    <ConfirmModal
      open={open}
      title="Vuoi uscire?"
      body={LOGOUT_BODY}
      confirmLabel={phase === 'error' ? 'Riprova' : 'Esci'}
      cancelLabel="Annulla"
      destructive
      busy={phase === 'pending'}
      status={phase === 'pending' ? 'Uscita in corso…' : undefined}
      error={phase === 'error' ? LOGOUT_ERROR : undefined}
      onConfirm={confirm}
      onCancel={cancel}
    />
  );
}
